import {
  ADD_KEY,
  ADD_KEY_FAILURE,
  ADD_KEY_SUCCESS,
  ADD_NOTES,
  ADD_NOTES_FAILURE,
  ADD_NOTES_SUCCESS,
  CANCEL_TRANSACTION,
  CANCEL_TRANSACTION_FAILURE,
  CANCEL_TRANSACTION_SUCCESS,
  CLEAR_EXPORT,
  CREATE_SESSION,
  CREATE_SESSION_FAILURE,
  CREATE_SESSION_SUCCESS,
  DELETE_KEY,
  DELETE_KEY_FAILURE,
  DELETE_KEY_SUCCESS,
  FETCH_CHARGES,
  FETCH_CHARGES_FAILURE,
  FETCH_CHARGES_SUCCESS,
  FETCH_CSV,
  FETCH_CSV_FAILURE,
  FETCH_CSV_SUCCESS,
  FETCH_GATEWAY_TRANSACTION,
  FETCH_GATEWAY_TRANSACTION_FAILURE,
  FETCH_GATEWAY_TRANSACTION_SUCCESS,
  FETCH_INDIVIDUAL_SETTLEMENT_CSV,
  FETCH_INDIVIDUAL_SETTLEMENT_CSV_FAILURE,
  FETCH_INDIVIDUAL_SETTLEMENT_CSV_SUCCESS,
  FETCH_INDIVIDUAL_TRANSACTIONS,
  FETCH_INDIVIDUAL_TRANSACTIONS_FAILURE,
  FETCH_INDIVIDUAL_TRANSACTIONS_SUCCESS,
  FETCH_INVOICE_CSV,
  FETCH_INVOICE_CSV_FAILURE,
  FETCH_INVOICE_CSV_SUCCESS,
  FETCH_KEYS,
  FETCH_KEYS_FAILURE,
  FETCH_KEYS_SUCCESS,
  FETCH_SESSIONS,
  FETCH_SESSIONS_FAILURE,
  FETCH_SESSIONS_SUCCESS,
  FETCH_TRANSACTIONS_SUMMARY,
  FETCH_TRANSACTIONS_SUMMARY_FAILURE,
  FETCH_TRANSACTIONS_SUMMARY_SUCCESS,
  FETCH_TRANSACTIONS,
  FETCH_TRANSACTIONS_FAILURE,
  FETCH_TRANSACTIONS_SUCCESS,
  RESET,
  RESET_CANCEL_TRANSACTION,
  TIPS,
  TIPS_FAILURE,
  TIPS_SUCCESS,
  TIPS_SUMMARY,
  TIPS_SUMMARY_FAILURE,
  TIPS_SUMMARY_SUCCESS,
  PAYMENT_ADJUSTMENT,
  PAYMENT_ADJUSTMENT_SUCCESS,
  PAYMENT_ADJUSTMENT_FAILURE,
  RESET_PAYMENT_ADJUSTMENT,
  CHARGE_CAPTURE,
  CHARGE_CAPTURE_SUCCESS,
  CHARGE_CAPTURE_FAILURE,
  CHARGE_REFUND,
  CHARGE_REFUND_SUCCESS,
  CHARGE_REFUND_FAILURE,
  CHARGE_CANCEL,
  CHARGE_CANCEL_SUCCESS,
  CHARGE_CANCEL_FAILURE,
} from './actions';
import { PAYMENTS } from './type';

export const INITIAL_STATE: PAYMENTS.PaymentReducer = {
  isLoading: 0,
  error: {} as PAYMENTS.Error,
  keys: {} as PAYMENTS.IPaginatedResponse<PAYMENTS.IApiKey>,
  key: {} as PAYMENTS.IApiKeyResponse,
  charges: {} as PAYMENTS.ICharge,
  transactions: {} as PAYMENTS.ITransactions,
  sessions: {} as PAYMENTS.ISessions,
  individualTransaction: {} as PAYMENTS.IIndividualTransaction,
  addedUser: false,
  addedKey: false,
  revokeKey: false,
  addedNote: false,
  created: false,
  url: '',
  exportResponse: {} as PAYMENTS.IExportResponse,
  addedSession: null,
  sessionResults: {} as PAYMENTS.ISessionResult,
  transactionSummary: {} as PAYMENTS.ITransactionSummary,
  cancelTransaction: false,
  gatewayTransaction: {} as PAYMENTS.IGatewayTransaction,
  tips: {} as PAYMENTS.ITips,
  tipsSummaryPaymentType: {} as PAYMENTS.TipByPaymentTypeAggregate,
  tipsSummaryEmployeeType: {} as PAYMENTS.TipByEmployeeAggregate,
  capturePaymentAdjustment: false,
  chargeCapture: false,
  chargeRefund: false,
  chargeCancel: false,
};

const paymentReducer = (
  action: IAction,
  state = INITIAL_STATE
): PAYMENTS.PaymentReducer => {
  switch (action.type) {
    case FETCH_TRANSACTIONS:
      return {
        ...state,
        isLoading: state.isLoading + 1,
        error: {},
      };
    case FETCH_TRANSACTIONS_SUCCESS:
      return {
        ...state,
        isLoading: Math.max(0, state.isLoading - 1),
        transactions: action.payload,
        error: {},
      };
    case FETCH_TRANSACTIONS_FAILURE:
      return {
        ...state,
        isLoading: Math.max(0, state.isLoading - 1),
        transactions: {} as PAYMENTS.ITransactions,
        error: { fetchTransactions: action.payload.message },
      };
    case FETCH_SESSIONS:
      return {
        ...state,
        isLoading: state.isLoading + 1,
        sessions: {} as PAYMENTS.ISessions,
        error: {},
      };
    case FETCH_SESSIONS_SUCCESS:
      return {
        ...state,
        isLoading: Math.max(0, state.isLoading - 1),
        sessions: action.payload,
        error: {},
      };
    case FETCH_SESSIONS_FAILURE:
      return {
        ...state,
        isLoading: Math.max(0, state.isLoading - 1),
        sessions: {} as PAYMENTS.ISessions,
        error: { fetchSessions: action.payload.message },
      };

    case FETCH_CSV:
      return {
        ...state,
        isLoading: state.isLoading + 1,
        error: {},
      };
    case FETCH_CSV_SUCCESS:
      return {
        ...state,
        isLoading: Math.max(0, state.isLoading - 1),
        url: action.payload.url,
        exportResponse: action.payload,
        error: {},
      };
    case FETCH_CSV_FAILURE:
      return {
        ...state,
        isLoading: Math.max(0, state.isLoading - 1),
        error: { addUrl: action.payload.data },
      };
    case FETCH_INDIVIDUAL_SETTLEMENT_CSV:
      return {
        ...state,
        isLoading: state.isLoading + 1,
        error: {},
      };
    case FETCH_INDIVIDUAL_SETTLEMENT_CSV_SUCCESS:
      return {
        ...state,
        isLoading: Math.max(0, state.isLoading - 1),
        url: action.payload.url,
        error: {},
      };
    case FETCH_INDIVIDUAL_SETTLEMENT_CSV_FAILURE:
      return {
        ...state,
        isLoading: Math.max(0, state.isLoading - 1),
        error: { fetchIndividualCsv: action.payload.message },
      };
    case FETCH_INDIVIDUAL_TRANSACTIONS:
      return {
        ...state,
        isLoading: state.isLoading + 1,
        error: {},
      };
    case FETCH_INDIVIDUAL_TRANSACTIONS_SUCCESS:
      return {
        ...state,
        isLoading: Math.max(0, state.isLoading - 1),
        individualTransaction: action.payload,
        error: {},
      };
    case FETCH_INDIVIDUAL_TRANSACTIONS_FAILURE:
      return {
        ...state,
        isLoading: Math.max(0, state.isLoading - 1),
        individualTransaction: {} as PAYMENTS.IIndividualTransaction,
        error: { addIndividualTransaction: action.payload.message },
      };
    case FETCH_CHARGES:
      return {
        ...state,
        isLoading: state.isLoading + 1,
        charges: {} as PAYMENTS.ICharge,
        error: {},
      };
    case FETCH_CHARGES_SUCCESS:
      return {
        ...state,
        isLoading: Math.max(0, state.isLoading - 1),
        charges: action.payload,
        error: {},
      };
    case FETCH_CHARGES_FAILURE:
      return {
        ...state,
        isLoading: Math.max(0, state.isLoading - 1),
        error: { charges: action.payload.message },
      };
    case CREATE_SESSION:
      return {
        ...state,
        isLoading: state.isLoading + 1,
        addedSession: null,
        error: {},
      };
    case CREATE_SESSION_SUCCESS:
      return {
        ...state,
        isLoading: Math.max(0, state.isLoading - 1),
        addedSession: action.payload,
        error: {},
      };
    case CREATE_SESSION_FAILURE:
      return {
        ...state,
        isLoading: Math.max(0, state.isLoading - 1),
        addedSession: null,
        error: { addSession: action.payload.message },
      };
    case ADD_KEY:
      return {
        ...state,
        isLoading: state.isLoading + 1,
        error: {},
        addedKey: false,
        key: {} as PAYMENTS.IApiKeyResponse,
      };
    case ADD_KEY_SUCCESS:
      return {
        ...state,
        isLoading: Math.max(0, state.isLoading - 1),
        error: {},
        key: action.payload,
        addedKey: true,
      };
    case ADD_KEY_FAILURE:
      return {
        ...state,
        isLoading: Math.max(0, state.isLoading - 1),
        key: {} as PAYMENTS.IApiKeyResponse,
        addedKey: false,
        error: {
          [action.payload.isPartnerKey ? 'addKeyPartner' : 'addKeySelf']:
            action.payload?.error?.response?.data,
        },
      };
    case DELETE_KEY:
      return {
        ...state,
        isLoading: state.isLoading + 1,
        revokeKey: false,
        error: {},
      };
    case DELETE_KEY_SUCCESS:
      return {
        ...state,
        isLoading: Math.max(0, state.isLoading - 1),
        revokeKey: true,
        error: {},
      };
    case DELETE_KEY_FAILURE:
      return {
        ...state,
        isLoading: Math.max(0, state.isLoading - 1),
        revokeKey: false,
        error: { deleteKey: action.payload.message },
      };

    case ADD_NOTES:
      return {
        ...state,
        isLoading: state.isLoading + 1,
        error: {},
        addedNote: false,
      };
    case ADD_NOTES_SUCCESS:
      return {
        ...state,
        isLoading: Math.max(0, state.isLoading - 1),
        error: {},
        addedNote: true,
      };
    case ADD_NOTES_FAILURE:
      return {
        ...state,
        isLoading: Math.max(0, state.isLoading - 1),
        addedNote: false,
        error: { addNotes: action.payload.message },
      };

    case FETCH_KEYS:
      return {
        ...state,
        isLoading: state.isLoading + 1,
        error: {},
        keys: {} as PAYMENTS.IPaginatedResponse<PAYMENTS.IApiKey>,
        addedKey: false,
      };
    case FETCH_KEYS_SUCCESS:
      return {
        ...state,
        isLoading: Math.max(0, state.isLoading - 1),
        error: {},
        keys: action.payload,
      };
    case FETCH_KEYS_FAILURE:
      return {
        ...state,
        isLoading: Math.max(0, state.isLoading - 1),
        keys: {} as PAYMENTS.IPaginatedResponse<PAYMENTS.IApiKey>,
        error: { fetchKeys: action.payload.message },
      };
    case RESET:
      return {
        ...INITIAL_STATE,
      };
    case CLEAR_EXPORT:
      return {
        ...state,
        url: '',
        exportResponse: {} as PAYMENTS.IExportResponse,
        error: {
          ...state.error,
          addUrl: undefined,
        },
      };
    case FETCH_TRANSACTIONS_SUMMARY:
      return {
        ...state,
        isLoading: state.isLoading + 1,
        transactionSummary: {} as PAYMENTS.ITransactionSummary,
      };
    case FETCH_TRANSACTIONS_SUMMARY_SUCCESS:
      return {
        ...state,
        isLoading: Math.max(0, state.isLoading - 1),
        transactionSummary: action.payload,
      };
    case FETCH_TRANSACTIONS_SUMMARY_FAILURE:
      return {
        ...state,
        isLoading: Math.max(0, state.isLoading - 1),
        transactionSummary: {} as PAYMENTS.ITransactionSummary,
        error: { fetchSummaryData: action.payload.message },
      };
    case CANCEL_TRANSACTION:
      return {
        ...state,
        isLoading: state.isLoading + 1,
        cancelTransaction: false,
        error: {},
      };
    case CANCEL_TRANSACTION_SUCCESS:
      return {
        ...state,
        isLoading: Math.max(0, state.isLoading - 1),
        cancelTransaction: true,
        error: {},
      };
    case CANCEL_TRANSACTION_FAILURE:
      return {
        ...state,
        isLoading: Math.max(0, state.isLoading - 1),
        cancelTransaction: false,
        error: { cancelTransaction: action.payload.message },
      };
    case RESET_CANCEL_TRANSACTION:
      return {
        ...state,
        cancelTransaction: false,
        error: {},
      };
    case FETCH_GATEWAY_TRANSACTION:
      return {
        ...state,
        isLoading: state.isLoading + 1,
        gatewayTransaction: {} as PAYMENTS.IGatewayTransaction,
        error: {},
      };
    case FETCH_GATEWAY_TRANSACTION_SUCCESS:
      return {
        ...state,
        isLoading: Math.max(0, state.isLoading - 1),
        gatewayTransaction: action.payload,
        error: {},
      };
    case FETCH_GATEWAY_TRANSACTION_FAILURE:
      return {
        ...state,
        isLoading: Math.max(0, state.isLoading - 1),
        gatewayTransaction: {} as PAYMENTS.IGatewayTransaction,
        error: { fetchGatewayTransaction: action.payload.message },
      };
    case TIPS:
      return {
        ...state,
        isLoading: state.isLoading + 1,
        error: {},
      };
    case TIPS_SUCCESS:
      return {
        ...state,
        isLoading: Math.max(0, state.isLoading - 1),
        tips: action.payload,
        error: {},
      };
    case TIPS_FAILURE:
      return {
        ...state,
        isLoading: Math.max(0, state.isLoading - 1),
        tips: {} as PAYMENTS.ITips,
        error: { tip: action.payload.message },
      };
    case TIPS_SUMMARY:
      return {
        ...state,
        isLoading: state.isLoading + 1,
        error: {},
      };
    case TIPS_SUMMARY_SUCCESS:
      return {
        ...state,
        isLoading: Math.max(0, state.isLoading - 1),
        tipsSummaryPaymentType:
          action.payload.type === 'payment_type'
            ? action.payload.data
            : ({} as PAYMENTS.TipByPaymentTypeAggregate),
        tipsSummaryEmployeeType:
          action.payload.type === 'employee' ? action.payload.data : [],
        error: {},
      };
    case TIPS_SUMMARY_FAILURE:
      return {
        ...state,
        isLoading: Math.max(0, state.isLoading - 1),
        tipsSummaryPaymentType: {} as PAYMENTS.TipByPaymentTypeAggregate,
        tipsSummaryEmployeeType: {} as PAYMENTS.TipByEmployeeAggregate,
        error: { tip: action.payload.message },
      };
    case PAYMENT_ADJUSTMENT:
      return {
        ...state,
        isLoading: state.isLoading + 1,
        capturePaymentAdjustment: false,
        error: {},
      };
    case PAYMENT_ADJUSTMENT_SUCCESS:
      return {
        ...state,
        isLoading: Math.max(0, state.isLoading - 1),
        capturePaymentAdjustment: true,
        error: {},
      };
    case PAYMENT_ADJUSTMENT_FAILURE:
      return {
        ...state,
        isLoading: Math.max(0, state.isLoading - 1),
        capturePaymentAdjustment: false,
        error: { paymentAdjustmentError: action.payload },
      };
    case RESET_PAYMENT_ADJUSTMENT:
      return {
        ...state,
        capturePaymentAdjustment: false,
        error: {},
      };
    case CHARGE_CAPTURE:
      return {
        ...state,
        isLoading: state.isLoading + 1,
        chargeCapture: false,
        error: {},
      };
    case CHARGE_CAPTURE_SUCCESS:
      return {
        ...state,
        isLoading: Math.max(0, state.isLoading - 1),
        chargeCapture: true,
        error: {},
      };
    case CHARGE_CAPTURE_FAILURE:
      return {
        ...state,
        isLoading: Math.max(0, state.isLoading - 1),
        chargeCapture: false,
        error: { chargeCaptureError: action.payload },
      };
    case CHARGE_REFUND:
      return {
        ...state,
        isLoading: state.isLoading + 1,
        chargeRefund: false,
        error: {},
      };
    case CHARGE_REFUND_SUCCESS:
      return {
        ...state,
        isLoading: Math.max(0, state.isLoading - 1),
        chargeRefund: true,
        error: {},
      };
    case CHARGE_REFUND_FAILURE:
      return {
        ...state,
        isLoading: Math.max(0, state.isLoading - 1),
        chargeRefund: false,
        error: { chargeRefundError: action.payload },
      };
    case CHARGE_CANCEL:
      return {
        ...state,
        isLoading: state.isLoading + 1,
        chargeCancel: false,
        error: {},
      };
    case CHARGE_CANCEL_SUCCESS:
      return {
        ...state,
        isLoading: Math.max(0, state.isLoading - 1),
        chargeCancel: true,
        error: {},
      };
    case CHARGE_CANCEL_FAILURE:
      return {
        ...state,
        isLoading: Math.max(0, state.isLoading - 1),
        chargeCancel: false,
        error: { chargeCancelError: action.payload },
      };
    case FETCH_INVOICE_CSV:
      return {
        ...state,
        isLoading: state.isLoading + 1,
        error: {},
      };
    case FETCH_INVOICE_CSV_SUCCESS:
      return {
        ...state,
        isLoading: Math.max(0, state.isLoading - 1),
        url: action.payload.url,
        exportResponse: action.payload,
        error: {},
      };
    case FETCH_INVOICE_CSV_FAILURE:
      return {
        ...state,
        isLoading: Math.max(0, state.isLoading - 1),
        error: { addUrl: action.payload.data },
      };
    default:
      return state;
  }
};
export default paymentReducer;
